import Dialog from 'rc-dialog';
import { IDialogPropTypes } from 'rc-dialog/lib/IDialogPropTypes';
import React from 'react';

import 'rc-dialog/assets/index.css';
import styled from 'styled-components';

import { Icon } from '../Icon';

export const Modal: React.FC<IDialogPropTypes> = (props) => (
  <StyledDialog
    animation="zoom"
    maskAnimation="fade"
    closeIcon={<Icon name="close" size="small" color="battleshipGrey" />}
    {...props}
  />
);

const StyledDialog = styled(Dialog)`
  .rc-dialog-content {
    border-radius: 0;

    .rc-dialog-header {
      border-bottom: ${({ theme: { colors } }) =>
        `3px solid ${colors?.r2d2Blue}`};
      color: ${({ theme: { colors } }) => colors?.battleshipGrey};
    }

    .rc-dialog-close {
      opacity: 1;
    }
  }
`;
